// extracted by mini-css-extract-plugin
export var container = "footer-module--container--5GliC";
export var item = "footer-module--item--zTjIK";
export var list = "footer-module--list--WbCnF";
export var nav = "footer-module--nav--V0nMP";